__turbopack_context__.v({
  "active": "matches-module__8iB8qq__active",
  "arrow": "matches-module__8iB8qq__arrow",
  "arrowContainer": "matches-module__8iB8qq__arrowContainer",
  "backBtn": "matches-module__8iB8qq__backBtn",
  "brandSection": "matches-module__8iB8qq__brandSection",
  "comparison": "matches-module__8iB8qq__comparison",
  "container": "matches-module__8iB8qq__container",
  "empty": "matches-module__8iB8qq__empty",
  "exactBadge": "matches-module__8iB8qq__exactBadge",
  "filterBar": "matches-module__8iB8qq__filterBar",
  "filterBtn": "matches-module__8iB8qq__filterBtn",
  "filters": "matches-module__8iB8qq__filters",
  "fuzzyBadge": "matches-module__8iB8qq__fuzzyBadge",
  "header": "matches-module__8iB8qq__header",
  "loading": "matches-module__8iB8qq__loading",
  "matchCard": "matches-module__8iB8qq__matchCard",
  "matchHeader": "matches-module__8iB8qq__matchHeader",
  "matchIndicator": "matches-module__8iB8qq__matchIndicator",
  "matchesGrid": "matches-module__8iB8qq__matchesGrid",
  "primaryBtn": "matches-module__8iB8qq__primaryBtn",
  "progressRing": "matches-module__8iB8qq__progressRing",
  "progressRingBg": "matches-module__8iB8qq__progressRingBg",
  "progressRingFill": "matches-module__8iB8qq__progressRingFill",
  "pulse": "matches-module__8iB8qq__pulse",
  "scoreCircle": "matches-module__8iB8qq__scoreCircle",
  "scoreText": "matches-module__8iB8qq__scoreText",
  "sectionTitle": "matches-module__8iB8qq__sectionTitle",
  "similarity": "matches-module__8iB8qq__similarity",
  "slider": "matches-module__8iB8qq__slider",
  "sliderGroup": "matches-module__8iB8qq__sliderGroup",
  "statCard": "matches-module__8iB8qq__statCard",
  "statLabel": "matches-module__8iB8qq__statLabel",
  "statValue": "matches-module__8iB8qq__statValue",
  "statsRow": "matches-module__8iB8qq__statsRow",
  "subtitle": "matches-module__8iB8qq__subtitle",
  "title": "matches-module__8iB8qq__title",
  "titleRow": "matches-module__8iB8qq__titleRow",
});
